var path = '/app/pages/stage-fifth/stage-fifth.html';
var html = "<stage-book class=fill type={{$ctrl.type}} title={{$ctrl.title}} zones=$ctrl.zones is-drop-custom-valid=$ctrl.isDropValidCustomBind forms=$ctrl.forms1 on-success=$ctrl.onSuccess() on-fail=$ctrl.onFail()> <stage-book-description> <h3 class=stage-book-category><font size=5>Complete o espaço que falta de acordo com os adesivos que já estão colocados.</font></h3> <h2 class=stage-book-category>Nível 2</h2> <div class=pointer></div> </stage-book-description> </stage-book> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/stage-fifth/stage-fifth.html
// module id = 267
// module chunks = 0